<template>
  <div class="py-4 sm:py-6 sm:px-8 max-w-screen-xl mx-auto">
    <PageEditor
      :page-path="route.path"
      :is-admin="authStore.isAdmin"
      show-loader
    />
  </div>
</template>
<script setup lang="ts">
import { useAuth } from '~/stores/auth'

const route = useRoute()
const authStore = useAuth()
</script>
